import React, { useState, useEffect } from 'react';
import PolicyModal from './PolicyModal';
import { useLanguage } from '../context/LanguageContext';

export const TERMS_STORAGE_KEY = 'ukiyo-terms-consent';
export const TERMS_DECLINED_SESSION_KEY = 'ukiyo-terms-declined';

const TermsBanner = ({ onAcceptTerms, onDeclineTerms }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [modalTab, setModalTab] = useState(null);
    const { t } = useLanguage();

    useEffect(() => {
        const syncVisibility = () => {
            const accepted = localStorage.getItem(TERMS_STORAGE_KEY) === 'accepted';
            const declinedSession = sessionStorage.getItem(TERMS_DECLINED_SESSION_KEY) === 'true';
            setIsVisible(!accepted && !declinedSession);
        };
        syncVisibility();
        window.addEventListener('ukiyo-terms-updated', syncVisibility);
        return () => window.removeEventListener('ukiyo-terms-updated', syncVisibility);
    }, []);

    const handleAccept = () => {
        localStorage.setItem(TERMS_STORAGE_KEY, 'accepted');
        sessionStorage.removeItem(TERMS_DECLINED_SESSION_KEY);
        setIsVisible(false);
        window.dispatchEvent(new Event('ukiyo-terms-updated'));
        if (onAcceptTerms) onAcceptTerms();
    };

    const handleDecline = () => {
        sessionStorage.setItem(TERMS_DECLINED_SESSION_KEY, 'true');
        setIsVisible(false);
        if (onDeclineTerms) onDeclineTerms();
    };

    if (!isVisible && !modalTab) return null;

    return (
        <>
            {isVisible && (
                <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 border-t border-[#b08d57]/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] p-4 sm:px-6">
                    <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
                        <div className="text-xs sm:text-sm text-gray-700 text-center md:text-start leading-relaxed max-w-3xl">
                            <span className="font-serif font-semibold text-gray-900 mx-1">
                                {t('storePoliciesBannerTitle')}
                            </span>
                            {t('pleaseReviewAndAccept')}{' '}
                            <button
                                type="button"
                                onClick={() => setModalTab('terms')}
                                className="text-[#8B6939] font-semibold underline hover:text-[#b08d57]"
                            >
                                {t('termsAndConditions')}
                            </button>
                            ,{' '}
                            <button
                                type="button"
                                onClick={() => setModalTab('return')}
                                className="text-[#8B6939] font-semibold underline hover:text-[#b08d57]"
                            >
                                {t('returnAndExchangePolicy')}
                            </button>
                            , {t('andText')}{' '}
                            <button
                                type="button"
                                onClick={() => setModalTab('buying')}
                                className="text-[#8B6939] font-semibold underline hover:text-[#b08d57]"
                            >
                                {t('buyingAndShippingPolicy')}
                            </button>
                            .
                        </div>

                        <div className="flex items-center gap-3 w-full md:w-auto justify-center flex-shrink-0">
                            <button
                                type="button"
                                onClick={handleDecline}
                                className="flex-1 md:flex-initial px-4 py-2 text-xs sm:text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                            >
                                {t('decline')}
                            </button>
                            <button
                                type="button"
                                onClick={handleAccept}
                                className="flex-1 md:flex-initial px-6 py-2 text-xs sm:text-sm font-semibold text-white bg-[#b08d57] hover:bg-[#9c7b4d] rounded-md shadow-sm transition-colors"
                            >
                                {t('acceptAll')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <PolicyModal
                isOpen={Boolean(modalTab)}
                onClose={() => setModalTab(null)}
                initialTab={modalTab || 'terms'}
                onAccept={handleAccept}
            />
        </>
    );
};

export default TermsBanner;
